/*
 The file contains the common validations for forms in marketplace. These validators can be used
 in conjunction with atlaskit Field component
*/
export const checkNonEmptyString = name => value => {
  if ((value !== null && value !== void 0 ? value : '').trim().length === 0) {
    return "".concat(name, " cannot be blank");
  }
};
export const checkNonEmptyDigits = name => value => {
  if ((value !== null && value !== void 0 ? value : '').match(/^\d+$/) === null) {
    return "".concat(name, " must be digits");
  }
};
export const checkNonEmptyAlphanumeric = name => value => {
  if ((value !== null && value !== void 0 ? value : '').match(/^\w+$/) === null) {
    return "".concat(name, " must be alphanumeric");
  }
};
export const checkMaxLength = (name, length) => value => {
  if ((value !== null && value !== void 0 ? value : '').length > length) {
    return "".concat(name, " cannot be longer than ").concat(length, " characters");
  }
};
export const checkLengthInRange = (name, min, max) => value => {
  if ((value !== null && value !== void 0 ? value : '').length < min || (value !== null && value !== void 0 ? value : '').length > max) {
    return "".concat(name, " must be between ").concat(min, " and ").concat(max, " characters long");
  }
};
export const checkValidHttpUrl = name => urlString => {
  let url;
  const errorString = "".concat(name, " must be an absolute URL starting with http or https");

  try {
    url = new URL(urlString);
  } catch (_unused) {
    return errorString;
  }

  const isValid = url.protocol === 'http:' || url.protocol === 'https:';
  if (!isValid) return errorString;
};